import { h } from 'preact';
import { EmbroideryDetails } from '../../embroidery-details';
import { t } from '../../../../theme/locales';
export const SelectItemRow = ({ unit , checked , disabled , onToggle , cartItems  })=>h('label', {
        className: `select-item${disabled ? ' select-item--disabled' : ''}`,
        key: unit.unitKey
    }, [
        h('input', {
            type: 'checkbox',
            className: 'select-item__checkbox',
            checked,
            disabled,
            onChange: ()=>onToggle(unit.unitKey)
        }),
        unit.item.image ? h('div', {
            className: 'select-item__image'
        }, [
            h('img', {
                src: unit.item.image,
                alt: unit.title
            })
        ]) : null,
        h('div', {
            className: 'select-item__details'
        }, [
            h('div', {
                className: 'select-item__title'
            }, unit.item.product_title),
            h('div', {
                className: 'select-item__variant-info'
            }, [
                h('span', {}, unit.item.variant_title)
            ]),
            h(EmbroideryDetails, {
                item: unit.item,
                cartItems
            }),
            disabled ? h('div', {
                className: 'select-item__badge select-item__badge--not-selectable'
            }, t('gift_wrapping.steps.select_items.not_selectable')) : null
        ])
    ]);
